import { memo } from 'react';
import { Stack } from '@mui/material';
import { useToggle } from '@dfl/hook-utils';
import { useParamsLink } from '@dfl/react-security';
import { useDeleteOrderStatus } from 'modules/sales/settings/order-status/hooks/useDeleteOrderStatus';
import { DeleteRowAction, EditRowActions } from '@dfl/mui-admin-layout';

type Props = {
  rowId?: string;
  allowDeleteAction?: boolean;
};

const OrderStatusRowActions = ({ rowId, allowDeleteAction = true }: Props) => {
  const { isOpen, onClose, onOpen } = useToggle();

  const handleEdit = useParamsLink({ edit: rowId });
  const { mutate, isPending, error } = useDeleteOrderStatus(rowId as string, onClose);

  return (
    <>
      <Stack direction='row' spacing={1} justifyContent='end'>
        <EditRowActions onClick={handleEdit} />
        {allowDeleteAction ? (
          <DeleteRowAction
            isOpen={isOpen}
            onOpen={onOpen}
            onClose={onClose}
            error={error}
            isLoading={isPending}
            onDelete={mutate}
          />
        ) : (
          <></>
        )}
      </Stack>
    </>
  );
};

export default memo(OrderStatusRowActions);
